import { render, staticRenderFns } from "./SalvarArquivo.vue?vue&type=template&id=1baade40"
import script from "./SalvarArquivo.vue?vue&type=script&lang=js"
export * from "./SalvarArquivo.vue?vue&type=script&lang=js"
import style0 from "./SalvarArquivo.vue?vue&type=style&index=0&id=1baade40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports